import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './i18n';

import { initializeAuth } from './features/auth/authentication';
import { initSentry, reportLegacyDomainUsage } from './libs/sentry.service';
import App from './App';

import '@fontsource-variable/bricolage-grotesque/index.css';
import '@fontsource-variable/host-grotesk/index.css';
import './index.css';

initSentry();
reportLegacyDomainUsage();
initializeAuth();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
